<div class="container-fluid px-2 px-md-3 px-xl-1 py-3">
  <div class="d-flex flex-column gap-3">
    <section class="entity-config-top mb-1 rounded-4 overflow-hidden shadow-sm">
      <div class="entity-config-top-hero px-2 px-md-3 py-3">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <p class="entity-page-title text-white fw-bold lh-sm mb-1">Organization Dashboard</p>
            <p class="entity-page-subtitle text-white mb-0 subsystem-subtitle">
              {{ organization.name || 'Organization' }}
              <span v-if="organization.external_org_id" class="mx-1">&bull;</span>
              <span>{{ organization.external_org_id || 'Configuration Matrix' }}</span>
            </p>
          </div>

          <div class="col-auto d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-light text-xs d-inline-flex align-items-center rounded-3 px-3 py-2 shadow-sm me-2 align-self-end"
              :disabled="loading"
              @click="load_dashboard"
            >
              <i class="bi bi-arrow-clockwise me-2"></i>
              Refresh
            </button>
            <button
              type="button"
              class="btn btn-primary-dark text-xs d-inline-flex align-items-center rounded-3 px-3 py-2 shadow-sm align-self-end"
              @click="go_to_route('OrganizationProjects')"
            >
              <i class="bi bi-plus-circle-fill me-2 text-white"></i>
              New Project
            </button>
          </div>
        </div>
      </div>

      <div class="px-2 px-md-3 pb-3">
        <section class="row g-2 entity-config-top-metrics">
          <div v-for="metric in metric_cards" :key="metric.label" class="col-12 col-md-6 col-xl-3 mt-2">
            <button
              type="button"
              class="entity-metric-card dashboard-clickable h-100 w-100 rounded-4 border shadow-sm p-3 text-start"
              @click="go_to_metric(metric)"
            >
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2 overflow-hidden">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2 text-truncate">
                    {{ metric.label }}
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ metric.value }}</div>
                  <div class="secondary-color text-xs fw-semibold mt-2 text-truncate">{{ metric.meta }}</div>
                </div>

                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white flex-shrink-0">
                  <i class="bi" :class="metric.icon"></i>
                </div>
              </div>
            </button>
          </div>
        </section>
      </div>
    </section>

    <div v-if="loading" class="d-flex align-items-center gap-2 text-secondary text-xs py-4">
      <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
      <span>Loading dashboard...</span>
    </div>

    <div v-if="error" class="alert alert-warning text-xs py-2 mb-3">
      {{ error }}
    </div>

    <div v-if="!loading && !error" class="d-flex flex-column gap-4">
      <div class="row g-3 align-items-stretch">
        <div class="col-12 col-xl-8">
          <section class="config-panel shadow-sm p-3 h-100">
            <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
              <div>
                <h2 class="fs-6 fw-bold mb-1">Subsystem Breakdown</h2>
                <div class="text-secondary text-xs fw-semibold">Counts across each configured subsystem</div>
              </div>
              <button
                type="button"
                class="btn btn-light btn-sm rounded-small text-xxs d-inline-flex align-items-center gap-2"
                @click="go_to_route('EntityConfigs')"
              >
                <i class="bi bi-diagram-3"></i>
                <span>Entity Configs</span>
              </button>
            </div>

            <div class="row g-2">
              <div v-for="subsystem in subsystem_breakdown" :key="subsystem.label" class="col-12 col-md-6 col-xl-4">
                <button
                  type="button"
                  class="subsystem-card dashboard-clickable w-100 h-100 bg-white border rounded-3 p-3 text-start shadow-sm"
                  @click="go_to_route(subsystem.routeName)"
                >
                  <div class="d-flex align-items-center justify-content-between gap-3">
                    <div class="d-flex align-items-center gap-2 overflow-hidden">
                      <span class="subsystem-icon d-inline-flex align-items-center justify-content-center flex-shrink-0">
                        <i class="bi" :class="subsystem.icon"></i>
                      </span>
                      <span class="fw-semibold text-xs text-truncate">{{ subsystem.label }}</span>
                    </div>
                    <span class="fw-bold text-primary">{{ subsystem.value }}</span>
                  </div>
                </button>
              </div>
            </div>
          </section>
        </div>

        <div class="col-12 col-xl-4">
          <section class="config-panel shadow-sm p-3 h-100">
            <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
              <div>
                <h2 class="fs-6 fw-bold mb-1">Active Users</h2>
                <div class="text-secondary text-xxs fw-semibold">{{ summary.active_users || 0 }} active of {{ summary.users || 0 }} users</div>
              </div>
              <button
                type="button"
                class="btn btn-sm text-decoration-none text-xs fw-bold p-0"
                @click="go_to_route('OrganizationUsers')"
              >
                View All
              </button>
            </div>

            <div v-if="active_users.length" class="d-flex flex-column gap-2">
              <button
                v-for="user in active_users"
                :key="user.id"
                type="button"
                class="dashboard-user-row dashboard-clickable bg-white border rounded-3 p-2 text-start shadow-sm"
                @click="go_to_route('OrganizationUsers')"
              >
                <div class="d-flex align-items-center gap-2">
                  <span class="dashboard-table-avatar d-inline-flex align-items-center justify-content-center fw-bold">
                    {{ (user.first_name || user.email || 'U').charAt(0) }}{{ (user.last_name || '').charAt(0) }}
                  </span>
                  <div class="overflow-hidden">
                    <div class="fw-bold text-xs text-truncate">{{ user.full_name || user.email || 'User' }}</div>
                    <div class="text-secondary text-xxs text-truncate">{{ user.email || 'Active user' }}</div>
                  </div>
                </div>
              </button>
            </div>

            <div v-else class="text-secondary text-xs py-3">
              No active users found.
            </div>
          </section>
        </div>
      </div>

      <div class="row g-3 align-items-stretch">
        <div class="col-12 col-xl-6">
          <section class="config-panel shadow-sm p-3 h-100">
            <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
              <div>
                <h2 class="fs-6 fw-bold mb-1">Projects</h2>
                <div class="text-secondary text-xxs fw-semibold">{{ summary.active_projects || 0 }} active projects</div>
              </div>
              <button type="button" class="btn btn-sm text-decoration-none text-xs fw-bold p-0" @click="go_to_route('OrganizationProjects')">
                View All
              </button>
            </div>

            <div v-if="recent_projects.length" class="d-flex flex-column">
              <button
                v-for="project in recent_projects"
                :key="project.id"
                type="button"
                class="config-row dashboard-clickable bg-transparent border-0 text-start py-2 px-0"
                @click="go_to_route('OrganizationProjects')"
              >
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div class="overflow-hidden">
                    <div class="fw-semibold text-xs text-truncate">{{ item_name(project) }}</div>
                    <div class="text-secondary text-xxs text-truncate">{{ project.project_description || project.description || 'Project' }}</div>
                  </div>
                  <span class="status-dot flex-shrink-0 mt-1" :class="{ active: project.is_active !== false }"></span>
                </div>
              </button>
            </div>

            <div v-else class="text-secondary text-xs py-3">
              No projects found.
            </div>
          </section>
        </div>

        <div class="col-12 col-xl-6">
          <section class="config-panel shadow-sm p-3 h-100">
            <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
              <div>
                <h2 class="fs-6 fw-bold mb-1">Entity Configs & Bindings</h2>
                <div class="text-secondary text-xxs fw-semibold">Click a config to manage subsystem bindings</div>
              </div>
              <button type="button" class="btn btn-sm text-decoration-none text-xs fw-bold p-0" @click="go_to_route('EntityConfigs')">
                View All
              </button>
            </div>

            <div v-if="(configurations.entity_configs || []).length" class="d-flex flex-column">
              <button
                v-for="item in configurations.entity_configs"
                :key="`entity-config-${item.id}`"
                type="button"
                class="config-row dashboard-clickable bg-transparent border-0 text-start py-2 px-0"
                @click="go_to_entity_subsystem_bindings(item)"
              >
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div class="overflow-hidden">
                    <div class="fw-semibold text-xs text-truncate">{{ item_name(item) }}</div>
                    <div class="text-secondary text-xxs text-truncate">{{ item_meta(item) || 'Manage subsystem bindings' }}</div>
                  </div>
                  <i class="bi bi-arrow-up-right text-secondary"></i>
                </div>
              </button>
            </div>

            <div v-else class="text-secondary text-xs py-3">
              No entity configs found.
            </div>
          </section>
        </div>
      </div>

      <section class="config-panel shadow-sm p-3">
        <div class="d-flex align-items-center justify-content-between gap-3 mb-2">
          <h2 class="fs-6 fw-bold mb-0">Recent Configuration Records</h2>
          <button type="button" class="btn btn-link btn-sm text-decoration-none text-xxs fw-bold p-0" @click="go_to_route('EntityConfigs')">
            Open Configurations
          </button>
        </div>

        <div class="row g-3">
          <div v-for="panel in recent_panels" :key="panel.title" class="col-12 col-xl-6">
            <section class="border rounded-3 p-3 h-100">
              <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
                <h3 class="fs-6 fw-bold mb-0">{{ panel.title }}</h3>
                <button type="button" class="btn btn-link btn-sm text-decoration-none p-0 text-xs" @click="go_to_route(panel.routeName)">
                  Open
                </button>
              </div>

              <div v-if="panel.items.length" class="d-flex flex-column">
                <button
                  v-for="item in panel.items"
                  :key="`${panel.title}-${item.id}`"
                  type="button"
                  class="config-row dashboard-clickable bg-transparent border-0 text-start py-2 px-0"
                  @click="go_to_route(panel.routeName)"
                >
                  <div class="d-flex align-items-start justify-content-between gap-2">
                    <div class="overflow-hidden">
                      <div class="fw-semibold text-xs text-truncate">{{ item_name(item) }}</div>
                      <div class="text-secondary text-xxs text-truncate">{{ item_meta(item) }}</div>
                    </div>
                    <span
                      v-if="item.is_active !== null && item.is_active !== undefined"
                      class="status-dot flex-shrink-0 mt-1"
                      :class="{ active: item.is_active }"
                    ></span>
                  </div>
                </button>
              </div>

              <div v-else class="text-secondary text-xs py-3">
                No records found.
              </div>
            </section>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
